var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"disabled":_vm.disabled},on:{"ready":_vm.ckeditorReady},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }